let isActive = false;

export const beginSchedulerDrag = () => {
  isActive = true;
};

export const endSchedulerDrag = () => {
  isActive = false;
};

export const getIsSchedulerDragActive = () => isActive;
